class SOSCookie {
    static create(type) {
        var result = new SOSCookie(type);
        const sc = CookiesController.readCookie(result.getSessionCookieName());
        if (sc != null)
            result.sessionValues = JSON.parse(sc);
        const ec = CookiesController.readCookie(result.getExpiryCookieName());
        if (ec != null) {
            result.expiryValues = JSON.parse(ec);
            const now = new Date();
            for (let i = result.expiryValues.length-1; i>=0; i--) {
                result.expiryValues[i].expiry = new Date(result.expiryValues[i].expiry);
                if (result.expiryValues[i].expiry.getTime() < now.getTime()) {
                    result.expiryValues.splice(i, 1);
                }
                else if (result.maxExpiry.getTime() < result.expiryValues[i].expiry.getTime())
                    result.maxExpiry = result.expiryValues[i].expiry;
            }
        } 
        return result;
    }
    constructor(name) {
        this.name = name;
        this.maxExpiry = new Date();
        this.sessionValues = [];
        this.expiryValues = [];
    }

    getValue(name) {
        let result = null;
        this.sessionValues.forEach((current) => {
            if (current.name === name) {
                result = current.value;
                return;
            }
        });
        if (result == null) {
            const now = new Date();
            this.expiryValues.forEach((current) => {
                if (current.name === name) {
                    const date = new Date(current.expiry);
                    // Return only not expired values
                    if (date.getTime() >= now.getTime())
                        result = current.value;
                    return;
                }
            });
        }
        return result;
    }
    deleteValue(name) {
        for (let i = this.sessionValues.length-1; i>=0; i-=1) {
            if (this.sessionValues[i].name === name) {
                this.sessionValues.splice(i, 1);
                break;
            }
        }
        for (let i = this.expiryValues.length-1; i>=0; i-=1) {
            if (this.expiryValues[i].name === name) {
                this.expiryValues.splice(i, 1);
                break;
            }
        }
    }
    // if expiry == -1 create a session cookie, if expiry > now create a cookie with expiry date,
    // if expiry < now delete and ignore it
    setValue(name, value, expiry) {
        const that = this;
        if (expiry.getTime() == -1) {
            let sFound = false;
            this.sessionValues.forEach((current) => {
                if (current.name === name) {
                    current.value = value;
                    sFound = true;
                    return;
                }
            });
            if (!sFound)
                this.sessionValues.push({ name: name, value: value });
            return;
        }
        const now = new Date();
        if (expiry.getTime() < now.getTime()) {
            // Already expired
            this.deleteValue(name);
            return;
        }

        let eFound = false;
        this.expiryValues.forEach((current) => {
            if (current.name === name) {
                current.value = value;
                current.expiry = expiry;
                eFound = true;
                if (expiry.getTime() > that.maxExpiry.getTime())
                    that.maxExpiry = expiry;
            }
        });
        if (!eFound)
            this.expiryValues.push({ name: name, value: value, expiry: expiry });
    }
    getSessionCookieName() {
        return `sos_${this.name}_session`;
    }
    getExpiryCookieName() {
        return `sos_${this.name}_expiry`;
    }
    save() {
        const session = this.sessionValues.lengeth != 0 ? JSON.stringify(this.sessionValues) : "";
        const expiry = this.expiryValues.lengeth != 0 ? JSON.stringify(this.expiryValues) : "";

        if (session !== "")
            CookiesController.createCookie(this.getSessionCookieName(), session);
        else
            CookiesController.eraseCookie(this.getSessionCookieName());
        if (expiry !== "")
            CookiesController.createCookie(this.getExpiryCookieName(), expiry, this.maxExpiry);
        else
            CookiesController.eraseCookie(this.getExpiryCookieName());
    }
}

export class CookiesController {
    static createCookie(name, value, expiryDate) {
        const date = new Date();
        const now = new Date();
        date.setTime(Date.parse(expiryDate));
        let expiryText = ''; // session cookie
        if (date > now) expiryText = `; expires=${date}`;

        document.cookie = `${name}=${value}${expiryText}; path=/;secure; SameSite=None`;
    }

    static createCookieWithDuration(name, value, duration) {
        const now = new Date();
        const newDate = new Date(now.getTime() + duration * 1000);
        document.cookie = `${name}=${value}; expires=${newDate}; path=/;secure; SameSite=None`;
    }

    static readCookie(name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    static eraseCookie(name) {
        CookiesController.createCookie(name, '', -1);
    }

    static readSOSCookie(type, name) {
        let c = SOSCookie.create(type);
        return c.getValue(name);
    }
    static eraseSOSCookie(type, name) {
        let c = SOSCookie.create(type);
        c.deleteValue(name);
        c.save();
    }
    static createSOSSessionCookie(type, name, value) {
        let c = SOSCookie.create(type);
        c.setValue(name, value, new Date(-1));
        c.save();
    }
    static createSOSCookie(type, name, value, expiryDate) {
        let c = SOSCookie.create(type);
        c.setValue(name, value, new Date(expiryDate));
        c.save();
    }
    static createSOSCookieWithDuration(type, name, value, duration) {
        const now = new Date();
        const newDate = new Date(now.getTime() + duration * 1000);
        let c = SOSCookie.create(type);
        c.setValue(name, value, newDate);
        c.save();
    }
}

// #endregion
